var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"url":_vm.url,"title":"لیست تیکت ها","detailUrl":_vm.detailUrl,"newUrl":_vm.newUrl,"fields":_vm.fields,"params":_vm.params,"tabTable":_vm.tabTable}})
}
var staticRenderFns = []

export { render, staticRenderFns }